const isMobile = window.innerWidth <= 1024;

export default isMobile;
